export const biddingStrategyType = {
  parent: 'InheritFromParent',
  manual: 'ManualCpc',
  manualCpa: 'ManualCpa',
  enhancedCPC: 'EnhancedCpc',
  maximizeClicks: 'MaxClicks',
  maximizeConversions: 'MaxConversions',
  targetCpa: 'TargetCpa',
  targetRoas: 'TargetRoas',
  maxConversionValue: 'MaxConversionValue',
  targetImpressionShare: 'TargetImpressionShare',
  biddingStrategyTypeId: {
    InheritFromParent: 0,
    ManualCpc: 1,
    MaxClicks: 2,
    MaxConversions: 3,
    TargetCpa: 4,
    EnhancedCpc: 5,
    TargetRoas: 6,
    MaxConversionValue: 8,
    TargetImpressionShare: 9,
    CostPerSale: 15,
    ManualCpa: 16,
  },
  biddingStrategyType: {
    0: 'InheritFromParent',
    1: 'ManualCpc',
    2: 'MaxClicks',
    3: 'MaxConversions',
    4: 'TargetCpa',
    5: 'EnhancedCpc',
    6: 'TargetRoas',
    8: 'MaxConversionValue',
    9: 'TargetImpressionShare',
    15: 'CostPerSale',
    16: 'ManualCpa',
  },
};
